import React from 'react'

import { FormPartsProps, textAreaHandleChange } from '~/common/form/formCommon'
import { TEXT_STRING_MAX_LENGTH } from '~/common/define/parameters'
import FormWidgetErrorMessages from '~/components/molecules/form/FormWidgetErrorMessages'
import TextArea, { TextAreaRow } from '~/components/atoms/textarea/TextArea'

export interface TextAreaProps extends FormPartsProps<string> {
  placeholder?: string
  maxlength?: number
  autoComplete?: string
  rows?: TextAreaRow
}

const FormTextArea = ({
                        name,
                        value,
                        onChange,
                        maxlength = TEXT_STRING_MAX_LENGTH,
                        autoComplete = 'off',
                        label = '',
                        placeholder = '',
                        errors = [],
                        rows = TextAreaRow.NORMAL
                      }: TextAreaProps) => {

  const handleChange = textAreaHandleChange(name, onChange)
  return (
    <>
      <TextArea
        name={name}
        value={value}
        onChange={handleChange}
        maxLength={maxlength}
        autoComplete={autoComplete}
        rows={rows}
        error={errors.length > 0}
        placeholder={placeholder}
      />
      {errors.length > 0 && <FormWidgetErrorMessages label={label} errors={errors}/>}
    </>
  )
}

export default FormTextArea